var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',[(_vm.shouldDisplay)?_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:(_vm.tooltip),expression:"tooltip",modifiers:{"hover":true}}],staticClass:"ml-1",attrs:{"icon":_vm.role.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }